import(/* webpackMode: "eager" */ "/app/frontend/app/(auth)/login/page.tsx");
